import React from "react";
import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import Modal from "src/components/Modal";
import { closeTestDriveModal, rescheduleTestDrive } from "src/store/actions/testDrive";
import { RouteComponentProps } from "react-router";
import TestDriveForm from "src/components/TestDrive/TestDriveForm";
import { getTestDriveDate, getTestDriveTime } from "src/store/selectors/testDrive";
import { getAccountDisclaimer } from "src/store/selectors/accountDisclaimers";
import "./styles.scss";
import MessageModal from "src/components/Modal/Components/MessageModal";
import CarIcon from "src/components/icons/Car";
import moment from "moment";
import { useTranslation } from "react-i18next";
import LightButton from "Shared/Buttons/LightButton";
import { AppointmentTime } from "Types/api/Appointment";

export const TestDriveModal = ({
    history,
    match: {
        isExact: isFormRoute, // true on `/my-garage/test-drive`, false on `/my-garage/test-drive/success`
    },
    title,
    formMessage,
    successMessage,
    date,
    time,
    rescheduleCtaText,
    closeModal,
    reschedule,
}: RouteComponentProps & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
    const { t } = useTranslation();

    const getTimeTrans = (appointmentTime: AppointmentTime) => {
        switch (appointmentTime) {
            case AppointmentTime.InTheMorning:
                return t("ContinueDeal.ScheduleAppointment.morning");
            case AppointmentTime.InTheAfternoon:
                return t("ContinueDeal.ScheduleAppointment.afternoon");
            case AppointmentTime.InTheEvening:
                return t("ContinueDeal.ScheduleAppointment.evening");
        }
    };

    return (
        <Modal open={true} closeModal={() => closeModal(history)}>
            <div className={"TestDriveModal"}>
                {isFormRoute ? (
                    <MessageModal icon={CarIcon} logoDisplayed={true} message={formMessage} title={title}>
                        <TestDriveForm />
                    </MessageModal>
                ) : (
                    <MessageModal
                        icon={CarIcon}
                        logoDisplayed={true}
                        message={
                            <>
                                <b>{`${t("TestDriveForm.success.header")} ${date}, ${getTimeTrans(time!)}.`}</b>
                                <br />
                                {successMessage}
                            </>
                        }
                        title={title}
                        waityButtons={[
                            {
                                onClickWithoutPromise: () => reschedule(history),
                                text: rescheduleCtaText,
                                buttonComponent: LightButton,
                            },
                            {
                                onClickWithoutPromise: () => closeModal(history),
                                text: t("MyGarage.GarageHeader.backToGarageBtn"),
                            },
                        ]}
                    />
                )}
            </div>
        </Modal>
    );
};

const mapStateToProps = (state: ApplicationStore) => ({
    title: getAccountDisclaimer(state, "test_drive_heading"),
    formMessage: getAccountDisclaimer(state, "test_drive_invitation"),
    successMessage: getAccountDisclaimer(state, "test_drive_success"),
    date: moment(getTestDriveDate(state)).format("dddd, MMMM Do"),
    time: getTestDriveTime(state),
    rescheduleCtaText: getAccountDisclaimer(state, "test_drive_reschedule_cta"),
});

const mapDispatchToProps = {
    reschedule: rescheduleTestDrive,
    closeModal: closeTestDriveModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(TestDriveModal);
